var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools collapse",attrs:{"data-collapsed":_vm.collapsed}},[_c('collapse-header',{attrs:{"title":_vm.title,"defaultCollapse":_vm.defaultCollapse},on:{"collapse":_vm.collapse}}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }